import { render } from "./Declaration.vue?vue&type=template&id=2baea6ce"
import script from "./Declaration.vue?vue&type=script&lang=js"
export * from "./Declaration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__